import { z } from "zod";
import { emailSchema, passwordSchema, phoneSchema } from "./common.js";
/**
 * Who is signing in or resetting: an email, or — since email is optional
 * (D-18) — a mobile number. Exactly what the one "Email or mobile" field
 * holds; see `loginIdFields`.
 */
const loginIdShape = {
    email: emailSchema.optional(),
    phone: phoneSchema.optional(),
};
const hasLoginId = (v) => Boolean(v.email || v.phone);
const loginIdMissing = { message: "Enter your email or mobile number", path: ["email"] };
/** Staff sign-in. Always scoped by the org slug in the URL (D-03, D-05). */
export const loginSchema = z
    .object({ ...loginIdShape, password: z.string().min(1, "Enter your password") })
    .refine(hasLoginId, loginIdMissing);
/** "Forgot password" takes the same email-or-mobile as sign-in. */
export const forgotPasswordSchema = z.object(loginIdShape).refine(hasLoginId, loginIdMissing);
/** The one sign-in field: anything with an "@" is an email, the rest a mobile number. */
export function loginIdFields(raw) {
    const value = raw.trim();
    return value.includes("@") ? { email: value } : { phone: value };
}
/** Karigar OTP request. */
export const otpRequestSchema = z.object({
    phone: phoneSchema,
});
export const otpVerifySchema = z.object({
    phone: phoneSchema,
    code: z
        .string()
        .trim()
        .regex(/^(?:\d{6}|00000)$/, "Enter the 6-digit code (00000 for demo accounts)"),
});
/** Forced first-login password change (D-04). */
export const setPasswordSchema = z
    .object({
    password: passwordSchema,
    confirm: z.string(),
})
    .refine((v) => v.password === v.confirm, {
    message: "Passwords do not match",
    path: ["confirm"],
});
//# sourceMappingURL=auth.js.map